import React, { Fragment, useEffect, useState } from 'react';
import MarksLedgFormView from '../../../../components/exam/report/marks_ledger/MarksLedgFormView';
import { fetchDataFromApi } from '../../../../widgets/api';
import AppURL from '../../../../widgets/AppURL';

const MarksLedgerFormView = () => {
    const [isOptions, setOnOptions] = useState([]);
    const EMISReportListView = async ()=>{
        try{
            await fetchDataFromApi(AppURL.EMISRPT+"emis-rpt-options-serach-list-view/").then((res)=>{
                setOnOptions(res);
            });
        }catch(error){
            console.log(error);
        }
    }
    useEffect(()=>{
        EMISReportListView();
    },[]);
  return (
    <Fragment>
      <MarksLedgFormView isOptions={isOptions} />
    </Fragment>
  )
}

export default MarksLedgerFormView
